module.exports = __webpack_public_path__ + "static/media/edwinVermulst.88c47c9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/edwinVermulst.jpg
// module id = 1670
// module chunks = 1